export const SEMESTER_MONTHS = {
	1: [
		{ id: 9, name: "September", short: "Sep" },
		{ id: 10, name: "October", short: "Oct" },
		{ id: 11, name: "November", short: "Nov" },
		{ id: 12, name: "December", short: "Dec" },
	],
	2: [
		{ id: 2, name: "February", short: "Feb" },
		{ id: 3, name: "March", short: "Mar" },
		{ id: 4, name: "April", short: "Apr" },
		{ id: 5, name: "May", short: "May" },
	],
};

export const VIEW_MODES = {
	SUBJECTS: "subjects",
	STUDENTS: "students",
};

export const getCurrentSemester = () => {
	const currentDate = new Date();
	const currentMonth = currentDate.getMonth() + 1;

	if (currentMonth >= 9 && currentMonth <= 12) {
		return 1;
	}
	return 2;
};

export const DEFAULT_SEMESTER = getCurrentSemester();
